/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_CompanyInputs */

const en_admin_external_booking_edit_company = /** @type {(inputs: Admin_External_Booking_Edit_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const de_admin_external_booking_edit_company = /** @type {(inputs: Admin_External_Booking_Edit_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen`)
};

const es_admin_external_booking_edit_company = /** @type {(inputs: Admin_External_Booking_Edit_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empresa`)
};

const fr_admin_external_booking_edit_company = /** @type {(inputs: Admin_External_Booking_Edit_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entreprise`)
};

const nl_admin_external_booking_edit_company = /** @type {(inputs: Admin_External_Booking_Edit_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedrijf`)
};

/** @type {(inputs: Admin_External_Booking_Edit_CompanyInputs) => LocalizedString} */
const it_admin_external_booking_edit_company = en_admin_external_booking_edit_company;

/** @type {(inputs: Admin_External_Booking_Edit_CompanyInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_company = en_admin_external_booking_edit_company;

/** @type {(inputs: Admin_External_Booking_Edit_CompanyInputs) => LocalizedString} */
const pl_admin_external_booking_edit_company = en_admin_external_booking_edit_company;

/** @type {(inputs: Admin_External_Booking_Edit_CompanyInputs) => LocalizedString} */
const hu_admin_external_booking_edit_company = en_admin_external_booking_edit_company;

/** @type {(inputs: Admin_External_Booking_Edit_CompanyInputs) => LocalizedString} */
const ro_admin_external_booking_edit_company = en_admin_external_booking_edit_company;

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Admin_External_Booking_Edit_CompanyInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_company = /** @type {((inputs?: Admin_External_Booking_Edit_CompanyInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_CompanyInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_company(inputs)
	if (locale === "de") return de_admin_external_booking_edit_company(inputs)
	if (locale === "es") return es_admin_external_booking_edit_company(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_company(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_company(inputs)
	if (locale === "it") return it_admin_external_booking_edit_company(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_company(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_company(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_company(inputs)
	return ro_admin_external_booking_edit_company(inputs)
});
export { admin_external_booking_edit_company as "admin.external_booking_edit.company" }